module.exports = require("jquery");


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 7
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external "jquery"